import base from "./palette";

export const lightPalette = {
    ...base,
    mode: "light" as const,
    primary: {
        main: "#2978ad",
        light: "#2e6ed1",
        dark: "#09377e",
        contrastText: "#ffffff",
    },
    background: { default: "#f6f7fa", paper: "#ffffff" },
    text: { primary: "#0b0f1a", secondary: "#3a4252" },
    divider: "#cacfd9",
};

export default lightPalette;
